module.exports = __webpack_public_path__ + "static/cooling-fan-33552c33e1d5e4fa2b30e50eae8a526a.jpg";